export default (id, prices) => {
  let pricing = prices?.find((price) => price.id === id);
  return pricing ? pricing.pivot : { dollars: null, percent: null };
};
